"use strict";

(function () {
  // This container manages the active view between the live simulation and the debrief
  var LiveSimContainer = function LiveSimContainer(_ref) {
    var sim = _ref.sim,
      view = _ref.view,
      setView = _ref.setView,
      resumeData = _ref.resumeData,
      onRestart = _ref.onRestart,
      sessionID = _ref.sessionID;
    var _window = window,
      LiveSimScreen = _window.LiveSimScreen,
      DebriefScreen = _window.DebriefScreen;

    // Auto-resume if data provided
    var _React = React,
      useEffect = _React.useEffect;
    useEffect(function () {
      if (resumeData) {
        // Logic already handled in App level restore
      }
    }, [resumeData]);

    // Back to the menu pauses the run, so it does not carry on unseen; the menu offers a way
    // straight back into it.
    var goBack = function goBack() {
      if (sim.state.isRunning) sim.pause();
      setView('setup');
    };
    // Finish ends the run for good, so it is not offered for resuming after a reload.
    var finish = function finish() {
      sim.stop();
      try {
        localStorage.removeItem('wmebem_sim_state');
      } catch (e) {}
      setView('debrief');
    };

    // Finish pressed by mistake: the debrief offers the way back into the same run (paused, so
    // the facilitator presses START when ready). The patient screens come back with it.
    var returnToScenario = function returnToScenario() {
      sim.dispatch({
        type: 'UNDO_FINISH'
      });
      sim.addLogEntry('Back to the scenario after Finish (facilitator)', 'system');
      setView('livesim');
    };
    if (view === 'debrief') {
      return /*#__PURE__*/React.createElement(DebriefScreen, {
        sim: sim,
        onExit: onRestart,
        onReturn: returnToScenario
      });
    }

    // Defib Sim scenarios get their own controller, on the same engine.
    if (sim.state.scenario && sim.state.scenario.defibSim && window.DefibSimScreen) {
      var DefibSimScreen = window.DefibSimScreen;
      return /*#__PURE__*/React.createElement(DefibSimScreen, {
        sim: sim,
        onFinish: finish,
        onBack: goBack,
        sessionID: sessionID
      });
    }
    return /*#__PURE__*/React.createElement(LiveSimScreen, {
      sim: sim,
      onFinish: finish,
      onBack: goBack,
      sessionID: sessionID
    });
  };
  window.LiveSimContainer = LiveSimContainer;
})();